<template>
  <div
    v-if="context.value.value[props.field.key]?.id !== '0'"
    class="offer-select-field w-100"
  >
    <v-container label="Angebote Auswahl">
      <BaseListV2
        ref="offerList"
        :loading="props.form.loading"
        :can-add="false"
        :has-detail-view="false"
        :can-reorder="false"
        :can-select="true"
        :can-delete="false"
        :pre-selected-rows="context.value.value[props.field.key]"
        :model-class="Offer"
        :can-copy-data="false"
        @row-selection="rowSelection"
      />
    </v-container>
  </div>
  <div v-else>
    <span>Angebote können nach dem Erstellen aktiviert werden.</span>
  </div>
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import BaseListV2 from '@/components/common/BaseListV2.vue'
import { Offer } from '@/models/commerce/offer'

import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()

const context = useFormKitContext()

const rowSelection = (offerIds) => {
  context.value.value.value[props.field.key] = offerIds
}
</script>
